import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import SubscriberResources from "@ane/exp-data/lib/resources/SubscriberResources";
const prefix = "LOAD_SUBSCRIBERS";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["items"],
  loadResource: (payload) => {
    return SubscriberResources.loadSubscribers(payload);
  },
  onCompleteSuccess: (result, inputPayload) => {
    return result;
  }
};
const loadSubscribersEpicReducer = loadResourcesUtils(args);
const LoadSubscribers_epics = combineEpics(loadSubscribersEpicReducer.epic);
export {
  LoadSubscribers_epics as default,
  loadSubscribersEpicReducer
};
//# sourceMappingURL=LoadSubscribers.epics.js.map
